import * as React from "react";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { withStores } from "stores";
import { withLocalization, LocalizedComponentProps } from "@shared-ui/localization-context";
import { PageHeadingProps } from "./typings";
import { UitkText } from "uitk-react-text";

@withLocalization
class PageHeading extends React.PureComponent<PageHeadingProps, LocalizedComponentProps> {
  public render() {
    const { pageHeading, pageSubHeadline } = this.props.compositionStore;
    const showPageSubHeader = this.props.flexComponent?.model?.showPageSubHeader;
    const pageHeadingView = () => {
      return (
        <>
          <span>{pageHeading}</span>
          {Boolean(pageSubHeadline) && (typeof showPageSubHeader === "undefined" || showPageSubHeader) && (
            <span className="uitk-type-400 uitk-type-regular all-t-margin-one">{pageSubHeadline}</span>
          )}
        </>
      );
    };

    if (!pageHeading) {
      return null;
    }

    if (this.props.flexComponent?.model?.view === "hidden") {
      return <h1 className="sr-only">{pageHeading}</h1>;
    } else if (this.props.flexComponent?.model?.view === "destination-discovery" && this.props.context) {
      return (
        <Viewport>
          <ViewSmall>
            <div className="uitk-cell all-cell-1-1 all-y-padding-four">
              <h1 className="uitk-type-display-800 uitk-flex uitk-flex-column">{pageHeadingView()}</h1>
            </div>
          </ViewSmall>

          <ViewLarge>
            <div className="SimpleContainer all-y-padding-three all-x-padding-three">
              <h1 className="uitk-type-display-900 uitk-flex uitk-flex-column all-b-margin-one">{pageHeadingView()}</h1>
            </div>
          </ViewLarge>
        </Viewport>
      );
    }

    return (
      <div
        className="PageHeading uitk-cell all-x-padding-three all-t-padding-six"
        data-fm={this.props.flexComponent.fmId}
        data-fm-title-id={this.props.flexComponent.fmTitleId}
      >
        <h1 className="uitk-type-heading-600">{pageHeading}</h1>
        {pageSubHeadline && (typeof showPageSubHeader === "undefined" || showPageSubHeader) && (
          <UitkText className="all-t-padding-one all-t-margin-two">{pageSubHeadline}</UitkText>
        )}
      </div>
    );
  }
}

export default withStores("compositionStore")(PageHeading);
